import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestCmpDetails extends WorkrequestDetailsBase {
  fire: boolean;
  zone: string;
  currentZoningSelectedItemId: number;
  serviceTappingSelected: boolean;
  serviceTappingQty: number;
  serviceTappingSize: number;
  serviceTappingFlow: number;
  fireServiceSelected: boolean;
  fireServiceQty: number;
  fireServiceSize: number;
  fireServiceFlow: number;
  mainMeterSelected: boolean;
  mainMeterQty: number;
  mainMeterSize: number;
  mainMeterFlow: number;
  checkMeterRSelected: boolean;
  checkMeterRSize: number;
  checkMeterRQty: number;
  checkMeterCSelected: boolean;
  checkMeterCSize: number;
  checkMeterCQty: number;
  existingServiceSelected: boolean;
  existingServiceDetails: string;
  existingMeterNumbersSelected: boolean;
  existingMeterNumbers: string;
  recycledTappingSelected: boolean;
  recycledTappingQty: number;
  recycledTappingSize: number;
  recycledTappingFlow: number;
  recycledMainMeterSelected: boolean;
  recycledMainMeterSize: number;
  recycledCheckMeterRSelected: boolean;
  recycledCheckMeterRSize: number;
  propertyOnCombinedDrain: string;
  connectingToExistingSewer: boolean;
  connectingToNewSewer: boolean;
  dischargeOfTradeWaste: boolean;

  booster: boolean;
  hydrant: boolean;
  sprinkler: boolean;
  hoseReel: boolean;
  pump: boolean;
  tank: boolean;
  designStandards: string;

  hydraulicPlansConfirmed: boolean;
  architecturalPlansConfirmed: boolean;
  basementPlansConfirmed: boolean;
  firePlansConfirmed: boolean;
  sitePlansConfirmed: boolean;
  groundAnchorsConfirmed: boolean;
  pumpCurvesConfirmed: boolean;
  planOfSubConfirmed: boolean;
  otherConfirmed: boolean;

  constructor() {
    super();
  }

  toUpperCase() {
    if (this.descriptionOfWork) {
      this.descriptionOfWork = this.descriptionOfWork.toUpperCase();
    }
  }

  appendWorkRequestDescription(detailedDescription: string) {
    this.descriptionOfWork = detailedDescription + '\r\nNote: \r\n';
    let i = 1;
    if (this.serviceTappingSelected) {
      this.descriptionOfWork += i + ') Service Tapping details ' + this.serviceTappingSize + ' mm '
        + this.serviceTappingFlow + ' L/s Qty: ' + this.serviceTappingQty + '\r\n';
      i++;
    }
    if (this.fireServiceSelected) {
      this.descriptionOfWork += i + ') Fire Service details ' + this.fireServiceSize + ' mm '
        + this.fireServiceFlow + ' L/s Qty: ' + this.fireServiceQty + '\r\n';
      i++;
    }
    if (this.mainMeterSelected) {
      this.descriptionOfWork += i + ') General Main Water Meter details ' + this.mainMeterSize + ' mm '
        + this.mainMeterFlow + ' L/s Qty: ' + this.mainMeterQty + '\r\n';
      i++;
    }
    if (this.checkMeterRSelected) {
      this.descriptionOfWork += i + ') Residential check meter details ' + this.checkMeterRSize + ' mm Qty: ' +
        this.checkMeterRQty + '\r\n';
      i++;
    }
    if (this.checkMeterCSelected) {
      this.descriptionOfWork += i + ') Commercial check meter details ' + this.checkMeterCSize + ' mm Qty: ' +
        this.checkMeterCQty + '\r\n';
      i++;
    }
    if (this.existingServiceSelected) {
      this.descriptionOfWork += i + ') Existing water service size ' + this.existingServiceDetails + '\r\n';
      i++;
    }
    if (this.existingMeterNumbersSelected) {
      this.descriptionOfWork += i + ') Existing water meter Number/s ' + this.existingMeterNumbers + '\r\n';
      i++;
    }
    if (this.recycledTappingSelected) {
      this.descriptionOfWork += i + ') Recycled Tapping details ' + this.recycledTappingSize + ' mm '
        + this.recycledTappingFlow + ' L/s Qty: ' + this.recycledTappingQty + '\r\n';
      i++;
    }
    if (this.recycledMainMeterSelected) {
      this.descriptionOfWork += i + ') Recycled Main Water Meter details ' + this.recycledMainMeterSize + ' mm\r\n';
      i++;
    }
    if (this.recycledCheckMeterRSelected) {
      this.descriptionOfWork += i + ') Recycled Residential check meter details ' + this.recycledCheckMeterRSize + ' mm\r\n';
      i++;
    }

    if (this.connectingToExistingSewer) {
      this.descriptionOfWork += i + ') Connecting to existing Sewer Connection Point option selected\r\n';
      i++;
    }

    if (this.connectingToNewSewer) {
      this.descriptionOfWork += i + ') Constructing and connecting to a new Greater Western Water Asset ' +
        '(branch or maintenance structure) option selected\r\n';
      i++;
    }

    if (this.dischargeOfTradeWaste) {
      this.descriptionOfWork += i + ') Discharge of Trade Waste option selected\r\n';
      i++;
    }

    if (this.fire) {
      if (this.booster) {
        this.descriptionOfWork += i + ') Booster Fire Cabinet/s option selected\r\n';
        i++;
      }

      if (this.hydrant) {
        this.descriptionOfWork += i + ') Hydrants option selected\r\n';
        i++;
      }

      if (this.sprinkler) {
        this.descriptionOfWork += i + ') Fire Sprinkler System option selected\r\n';
        i++;
      }

      if (this.hoseReel) {
        this.descriptionOfWork += i + ') Hose Reels option selected\r\n';
        i++;
      }

      if (this.pump) {
        this.descriptionOfWork += i + ') In-Line Pumps (for Fire Services and/or General Services) option selected\r\n';
        i++;
      }

      if (this.tank) {
        this.descriptionOfWork += i + ') Water Holding Tanks (Below or Above Ground) option selected\r\n';
        i++;
      }

      if (this.designStandards) {
        this.descriptionOfWork += i + ') Fire Service Design Standard/s: ' + ' ' + this.designStandards + '\r\n';
        i++;
      }
    }
    if (this.hydraulicPlansConfirmed) {
      this.descriptionOfWork += i + ') Full set of Hydraulic Plans (for Sewer & Water) uploaded\r\n';
      i++;
    }
    if (this.architecturalPlansConfirmed) {
      this.descriptionOfWork += i + ') Architectural Plans uploaded\r\n';
      i++;
    }
    if (this.basementPlansConfirmed) {
      this.descriptionOfWork += i + ') Basement plans & works method statement uploaded\r\n';
      i++;
    }
    if (this.firePlansConfirmed) {
      this.descriptionOfWork += i + ') Fire Service Plans uploaded\r\n';
      i++;
    }
    if (this.sitePlansConfirmed) {
      this.descriptionOfWork += i + ') Site Plans uploaded\r\n';
      i++;
    }
    if (this.groundAnchorsConfirmed) {
      this.descriptionOfWork += i + ') Ground Anchors Plans uploaded\r\n';
      i++;
    }
    if (this.pumpCurvesConfirmed) {
      this.descriptionOfWork += i + ') Pump Curves and Pump Information uploaded\r\n';
      i++;
    }
    if (this.planOfSubConfirmed) {
      this.descriptionOfWork += i + ') Plan of Subdivision uploaded\r\n';
      i++;
    }
    if (this.otherConfirmed) {
      this.descriptionOfWork += i + ') Other Plans uploaded\r\n';
      i++;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/cmp-form/workrequest-cmp-details.ts